/* eslint-disable-next-line  no-unused-vars */
import React, { createElement } from 'react';

export default function loaderHelper() {
    const open = () => {
        let doc = document.getElementById('map-loader');
        doc.hidden = false;
        console.log("open")
    };

    const close = (duration) => {
        let doc = document.getElementById('map-loader');
        if (duration) {
            setTimeout(() => {
                doc.hidden = true;

            }, duration * 1000); //
        } else {
            doc.hidden = true;
        }
    };

    return { open, close };
}
